<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Luma Campaigns</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button mat-button color="lightGreen" (click)="createCampaign()">Create Campaign</button>
  </div>
  </div>

<div class="campaigns">
  <div class="container campaigns-container" *ngIf="!isLoading; else loadingTpl">
    <div class="container-content">
      <table mat-table [dataSource]="dataSource" class="mat-table">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">{{ row.status | statusHumanize }}</td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let row">{{ row.created_at | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let row">{{ row.updated_at | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="stats">
          <th mat-header-cell *matHeaderCellDef>{{ statsHeader }}</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="sendgridEnabled; else noSendgrid">
              {{ row.total_recipients || 0 }}/{{ row.generated_count || 0 }}/{{ row.sent_count || 0 }}
            </ng-container>
            <ng-template #noSendgrid>
              {{ row.total_recipients || 0 }}/{{ row.generated_count || 0 }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button mat-icon-button aria-label="View" (click)="viewCampaign(row)" matTooltip="View Campaign">
              <svg-icon
                src="assets/svg/view.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button mat-icon-button aria-label="Edit" (click)="editCampaign(row)" [disabled]="row.status === 'pending_send' || row.status === 'send_complete'" matTooltip="Edit Campaign">
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button mat-icon-button aria-label="Duplicate" (click)="duplicateCampaign(row)" matTooltip="Duplicate Campaign">
              <svg-icon
                src="assets/svg/copy.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button
              mat-icon-button
              aria-label="Download"
              [matMenuTriggerFor]="downloadMenu"
              [disabled]="!canDownload(row)"
              matTooltip="Download Email Content"
            >
              <svg-icon
                src="assets/svg/download.svg"
                [svgClass]="canDownload(row) ? 'lightBlue' : 'lightGreyIcon'"
              ></svg-icon>
            </button>
            <mat-menu #downloadMenu="matMenu">
              <button mat-menu-item (click)="downloadCampaign(row, 'csv')" matTooltip="Download CSV (.zip)">CSV (.zip)</button>
              <button mat-menu-item (click)="downloadCampaign(row, 'xlsx')" matTooltip="Download XLSX (.zip)">XLSX (.zip)</button>
              <button mat-menu-item (click)="downloadCampaign(row, 'eml')" matTooltip="Download EML (.zip)">EML (.zip)</button>
            </mat-menu>
            <button mat-icon-button color="warn" aria-label="Delete" (click)="deleteCampaign(row)" matTooltip="Delete Campaign">
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="loading">Loading…</div>
</ng-template>


